// extracted by mini-css-extract-plugin
module.exports = {"loader":"authwrapper_loader__3K4Eh","logo-container":"authwrapper_logo-container__AJcTx","loader-logo":"authwrapper_loader-logo__3Up0c"};